// extracted by mini-css-extract-plugin
module.exports = {"textStyle":"parallax-module--textStyle--125Es"};